import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DynamicDialogComponent } from 'primeng/dynamicdialog';

@Component({
  selector: 'split-agenda-excecao',
  templateUrl: './agenda-excecao.component.html',
  styleUrls: ['./agenda-excecao.component.scss']
})
export class AgendaExcecaoComponent {
  form: FormGroup = new FormGroup({
    servicos: new FormControl()
  });
  hora1 = '10:40';
  hora2 = '12:20';
  unidade ='';

  constructor(public config: DynamicDialogComponent) {

  }
  salvar() {
    this.config.close();
  }
  cancelar() {
    this.config.close();
  }
}
